import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import keycode from "keycode";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import Skeleton from "react-loading-skeleton";


const DataTableHead = (props) => {

  // const createSortHandler = (event, property) => {
  //   // console.log("Firing createSortHandler");
  //   props.onRequestSort(event, property);
  // };

    const {columnData} = props;
    const [data, setData] = useState([]);

    useEffect(() => {
      setData(columnData);
      // console.log("data is ", data);
    }, [columnData]);

    return (
      <TableHead>
        <TableRow>
          {/*TODO: Uncomment this to show the checkbox*/}
          {/*<TableCell padding="checkbox">*/}
          {/*  <Checkbox color="primary"*/}
          {/*            indeterminate={numSelected > 0 && numSelected < rowCount}*/}
          {/*            checked={numSelected === rowCount}*/}
          {/*            onChange={onSelectAllClick}*/}
          {/*  />*/}
          {/*</TableCell>*/}
          {data.map(column => {
            return (
              <TableCell
                key={column.id}
                align={column.numeric}
                padding={column.disablePadding ? "none" : "default"}
              >
                {/*TODO: Uncomment these sections to allow UI to sort the table*/}
                {/*<Tooltip*/}
                {/*  title="Sort"*/}
                {/*  placement={column.numeric ? "bottom-end" : "bottom-start"}*/}
                {/*  enterDelay={300}*/}
                {/*>*/}
                {/*  <TableSortLabel*/}
                {/*    active={orderBy === column.id}*/}
                {/*    direction={order}*/}
                {/*    onClick={(event) => createSortHandler(event, column.id)}*/}
                {/*  >*/}
                    {column.label}
                {/*  </TableSortLabel>*/}
                {/*</Tooltip>*/}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
};

DataTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  columnData: PropTypes.array,
};


let DataTableToolbar = props => {
  const {numSelected, title} = props;

  return (
    <Toolbar className="table-header">
      <div className="title">
        {numSelected > 0 ? (
          <Typography variant="subheading">{numSelected} selected</Typography>
        ) : (
          <h2 variant="title" className={"arrayTableTitle bb-font-fridge-bold"}>{title}</h2>
        )}
      </div>
      <div className="spacer"/>
      <div className="actions">
        {numSelected > 0 && (
          <Tooltip title="Delete">
            <IconButton aria-label="Delete">
              <DeleteIcon/>
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  );
};

DataTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired
  ]),
};


const ArrayDataTable = (props) => {

  const {tableData, columnHeaders, title, loading, numSkeletonRows, currentPage = 0, maxRecordsDisplayOverride = false, overrideRowsPerPage = 10} = props;
  const skeletonRows = numSkeletonRows? numSkeletonRows : 3;
  // console.log("Displaying a data table.  Loading is:", loading);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [selected, setSelected] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [columnHeaderOverride, setColumnHeaderOverride] = useState([]); //if headings are passed in, they will be stored here and override the tableData
  const [data, setData] = useState([]);
  const [page, setPage] = useState(currentPage);
  const [rowsPerPage, setRowsPerPage] = useState(overrideRowsPerPage);

   // console.log("the table data is, ", data);

  const getUniqueGhosts = (tableData) => {
    const ghosts = tableData.filter((row) => row.hasOwnProperty("ghost"));
    return [...new Set(ghosts)];
  }

  const callGhostFunction = (withPageOf, uniqueGhosts) => {
    const applicableGhostFunctions = uniqueGhosts
        .filter((ghost) => ghost.fetchPage === withPageOf)
        .map((ghost) => {
          return {
            "fetchFunction" : ghost.fetchFunction,
            "fetchPage" : ghost.fetchPage
          }
        })
    //const uniqueGhostFunctions = applicableGhostFunctions.filter((item, index) => applicableGhostFunctions.indexOf(item) === index)
    // console.log("From uniqueGhosts ", uniqueGhosts, "and withPageOf", withPageOf, "found these applicable", applicableGhostFunctions)

    if (applicableGhostFunctions.hasOwnProperty(0)) {
      // console.log("About to call", applicableGhostFunctions[0].fetchFunction, "with page ", applicableGhostFunctions[0].fetchPage)
      applicableGhostFunctions[0].fetchFunction(applicableGhostFunctions[0].fetchPage)
    }
  }

  const getPageAndKeepInBounds = () => {
    const numRecords = data ? data.length : 0;
    const maxPossiblePage = Math.floor(numRecords / rowsPerPage);
    if (page > maxPossiblePage) {
      // console.log("Page may be out of bounds.  Setting to ", maxPossiblePage, "based on numRecords", numRecords, "rowsPerPage", rowsPerPage)
      setPage(maxPossiblePage);
    } else {
      // console.log("Page appears to be in range.  page ", page, "Max possible: ", maxPossiblePage, "numrecords", numRecords, "rowsPerPage", rowsPerPage)
    }
      return page;
  }

  useEffect(() => {
    if (tableData && tableData.length) {
      //tableData has arrived, update heading columns
      const newColumnData = Object.keys(tableData[0]).map((columnName) => {
        return (
            {
              id: columnName,
              align: true,
              disablePadding: true,
              label: columnName
            }
        )
      })
      setColumnData(newColumnData);

      //update the table data
      setData(tableData);
      // console.log("now the table data is, ", data);

      //also, call the fetch functions for any ghosts in view
      //if
    } else {
      //the table data must/might be empty array.
      setData(tableData ? tableData : []);
    }

    if (columnHeaders && columnHeaders.length) { //if dedicated column Headers were given, then use them
      setColumnHeaderOverride(columnHeaders.map((columnName) => {
        return (
            {
              id: columnName,
              align: true,
              disablePadding: false,
              label: columnName
            }
        )
      }));
    }
    if (overrideRowsPerPage) {
      setRowsPerPage(overrideRowsPerPage)
    }
  }, [tableData, columnHeaders, overrideRowsPerPage]);

  const handleRequestSort = (event, property) => {
    // console.log("DT sort pressed.")
    const orderBy = property;
    let order = "desc";

    if (orderBy === property && order === "desc") {
      order = "asc";
    }

    const items =
      order === "desc"
        ? data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
        : data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

    setData(items);
    setOrder(order);
    setOrderBy(orderBy);
  };

  const handleSelectAllClick = (event, checked) => {
    if (checked) {
      setSelected(data.map(n => n.id));
      return;
    }
    setSelected([]);
  };

  const handleKeyDown = (event, id) => {
    if (keycode(event) === "space") {
      handleClick(event, id);
    }
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, page) => {
    setPage(page);
    // console.log("handleChangePage here is the tableData", tableData)
    callGhostFunction((page + 1), getUniqueGhosts(tableData));
  };

  const handleChangeRowsPerPage = event => {
   //TODO remove to restore normal page rows per table functionality
    // setRowsPerPage(event.target.value);
  };

  let isSelected = id => selected.indexOf(id) !== -1;

  const createSkeletonRows = (numRows = 5) => {
    let rows = [];

    if (columnHeaders.length) {
      for (const r in [...Array(numRows)]) {
        let row = [];
      // row.push(<TableCell padding="checkbox"><Skeleton/></TableCell>);
        for (const column in columnHeaders) {
          row.push(<TableCell key={`${r}_${column}_skelecell`}><Skeleton/></TableCell>);
        }
        rows.push(<TableRow key={r} hover={false}>{row}</TableRow>);
      }
      return rows;
    } else {
      return (
          <Skeleton count = {numRows}/>
      )
    }
  };

  const isEnoughDataForNextPage = () => {

    const lengthOfDataOnHand = (data ? data.length : 0)
    const maxRecords = maxRecordsDisplayOverride ? maxRecordsDisplayOverride : lengthOfDataOnHand

    if (maxRecords <= lengthOfDataOnHand) {
      //there is enough records because its full
      return true
    } else {
      //there are more records than on hand
      const maxPageOfDataOnHand = Math.ceil(lengthOfDataOnHand / rowsPerPage) - 1;
      // const numRecordsForNextPage = (page + 1 + 1) * rowsPerPage;
      // console.log("isEnoughDataForNextPage maxPageOfDataOnHand", maxPageOfDataOnHand, " numRecordsForNextPage", numRecordsForNextPage, " page", page, "lengthOfDataOnHand", lengthOfDataOnHand)
      return maxPageOfDataOnHand >= (page + 1 );
    }

  }


  return (
    <Paper style={{marginBottom: "30px"}} >
      <DataTableToolbar numSelected={selected.length} title = {title}/>
      <div className="flex-auto">
        <div className="table-responsive-material">
          <Table className="">
            <DataTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={data? data.length : 0}
              columnData={columnHeaderOverride.length? columnHeaderOverride : columnData}
            />
            <TableBody>
              {(!tableData || loading) && (
                  createSkeletonRows(skeletonRows)
                )
              }

              {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                const isSelect = isSelected(n.id);
                let rows = []
                let shouldHover = true
                // console.log("creating row, n.bbFrontendClasses is ", n.bbFrontendClasses)
                if (columnData.length) {
                  for (const column in columnData) {
                    const columnName = columnData[column].id

                    if (n.hasOwnProperty("ghost") && column !== 0) { //skip the first cell to compensate for hidden id field.
                      //this is a ghost row
                      shouldHover = false
                      rows.push(<TableCell key={`${n.id}_${columnName}_skelecell`}><Skeleton/></TableCell>);
                    } else if(columnName !== "id" && columnName !== "bbFrontendClasses" && columnName !== "bbFrontendStyles") { //"id" is a special name, don't actually print that. that is just used for react keys
                      // console.log("Creating cells based on this columnData, ", columnData[column], columnName, n[columnName]);
                      rows.push(<TableCell key={`${n.id}_${columnName}`}>{n[columnName]}</TableCell>);
                    }
                  }

                }
                return (
                    <TableRow
                        hover={shouldHover}
                        // TODO: re-enable clicking selecting a single row
                        // onClick={event => handleClick(event, n.id)}
                        onKeyDown={event => handleKeyDown(event, n.id)}
                        role="checkbox"
                        aria-checked={isSelect}
                        tabIndex={-1}
                        key={n.id}
                        selected={isSelect}
                        className={n.bbFrontendClasses}
                        style={n.bbFrontendStyles}
                        // className={"bg-bb-risk-high pulse"}


                    >
                      {/*TODO: uncomment this to add the checkbox in the table*/}
                      {/*<TableCell padding="checkbox">*/}
                      {/*  <Checkbox color="primary" checked={isSelect}/>*/}
                      {/*</TableCell>*/}
                      {rows}

                    </TableRow>
                );
              })}
              {(tableData && !data.length) && <TableRow hover={false}><TableCell align={'center'} colSpan={columnHeaders.length ? columnHeaders.length : 1}>No Items In This Section</TableCell></TableRow>}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={maxRecordsDisplayOverride ? maxRecordsDisplayOverride : data? data.length : 0}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={[rowsPerPage]}
                  page={getPageAndKeepInBounds()}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                    //if the next page would need records beyond what already have, disable
                  nextIconButtonProps = {!isEnoughDataForNextPage() ? {"disabled" : true} : null}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </div>
    </Paper>
  );
};
ArrayDataTable.propTypes = {
  tableData: PropTypes.array,
  columnHeaders: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired
  ]),
  loading: PropTypes.bool,
  numSkeletonRows: PropTypes.number,
  defaultRowsPerPage: PropTypes.number,
  currentPage: PropTypes.number,
  fetchMore: PropTypes.func,
};

export default ArrayDataTable;
